<template>
  <div>
    <!-- Overall Rating -->
    <ship-graph-logistics
      class="mx-auto"
      :ship-types="Object.values(shipTypes)"
      style="width: 40rem;height: 40rem;"
    />
  </div>
</template>

<script>
import ShipGraphLogistics from "@/components/charts/ships/ShipGraphLogistics";
import { mapGetters } from "vuex";
export default {
  name: "ShipCategoryLogistics",
  components: { ShipGraphLogistics },
  computed: {
    ...mapGetters("data", ["shipTypes"])
  }
};
</script>

<style scoped></style>
